export default __webpack_public_path__ + "img/b411ab4bd1af67f6fb5ce4bddbffefc2.png";